<template>
  <v-container fluid>
    <v-card 
      class="mx-auto" 
      outlined
    >
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" md="3" xs="12">
            <v-select
              v-model="database"
              class="select_box"
              :items="databaseOptions"
              label="Database"
              dense
              outlined
            />
          </v-col>
          <v-col cols="12" md="3" xs="12">
            <v-select
              v-model="level"
              class="select_box"
              :items="levels"
              label="Level"
              dense
              outlined
              @change="loadTaxoData()"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-row no-gutters>
              <v-col cols="4" md="4" xs="4">
                <span style="display:flex;flex-direction:column;">
                  <span class="chip_title">
                    Read Count
                  </span>
                  <span style="text-align:center;">
                    {{ numberWithCommas(selectedRowDataSaved.read) }}
                  </span>
                </span>
              </v-col>
              <v-col cols="4" md="4" xs="4">
                <span style="display:flex;flex-direction:column;">
                  <span class="chip_title">
                    Q20%
                  </span>
                  <span style="text-align:center;">
                    {{ selectedRowDataSaved.ratioQ20 }}
                  </span>
                </span>
              </v-col>
              <v-col cols="4" md="4" xs="4">
                <span style="display:flex;flex-direction:column;">
                  <span class="chip_title">
                    Q30%
                  </span>
                  <span style="text-align:center;">
                    {{ selectedRowDataSaved.ratioQ30 }}
                  </span>
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="2" xs="12">
            <div class="chip">
              <div class="chip_title">
                FastQC Report
              </div>
              <div style="color:#1E88E5;">
                <span @click="linkFastQC('R1')" style="margin-right:20px;cursor:pointer;">Foword</span>
                <span @click="linkFastQC('R2')" style="cursor:pointer;">Reserve</span>                
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-card 
      style="margin-top:15px;" 
      outlined
    >
      <div style="margin-left:2vw;">
        <iframe
          :key="componentKeyForKrona"
          ref="iframe"
          style="border:0px;"
          title="Inline Frame Example"
          width="100%"
          height="1000"
          :srcdoc="fileContent"
        />
      </div>
    </v-card>
    <v-snackbar v-model="saveSnackbar">
      hi
      <template v-slot:action="{ attrs }">
        <v-btn 
          text 
          v-bind="attrs" 
          @click="saveSnackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import 'tui-grid/dist/tui-grid.css'
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import 'tui-pagination/dist/tui-pagination.css';
import _ from 'lodash';
import Big from 'big.js';

var CustomText = function(props) {
  let div = document.createElement("div");
  var el = document.createElement("button");
  // const isReply = props.grid.store.data.rawData[props.rowKey].isReply
  if (props.formattedValue == "") {
    div.innerHTML =
    `<span class="v-btn__content"><b>&nbsp;</b></span>`;
  } else {
    div.innerHTML =
    `<div style="text-align:right;cursor:auto;">&nbsp;${props.value}%</div>`;
  }

  const { grid, rowKey, columnInfo } = props;
  el.addEventListener("click", () => {});
  el.style.width = "calc(100% - 10px)";
  el.style.margin = "0px 0px 0px 0px";
  div.style.height = "20px";
  div.style.width = "115px";
  div.appendChild(el);

  this.el = div;
  this.render(props);
};

CustomText.prototype.getElement = function() {
  return this.el;
};
CustomText.prototype.getValue = function() {
  return this.el.value;
};
CustomText.prototype.render = function(props) {
  this.el.value = props.value;
};


export default {
  components: {
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    selectedRowDataSaved: {
      type: Object,
      defaultValue: [],
    },
    // eslint-disable-next-line vue/require-default-prop
    reset: {
      type: Number,
      defaultValue: 0
    }
  },
  data: () => ({
    componentKeyForKrona: 1,
    kronaPath: '',
    maxAbsoluteDepth: 7,
    target: '',
    database: 'Silva r138',
    originData: [],
    getBarChart: false,
    getDonutChart: false,
    relativeNum: 1.0,
    fileContent: '',
    saveSnackbar: false,
    barChartData: [],
    barChartDataLength: 390,
    donutChartDataLength: 1050,
    donutChartData: [],
    donutChartLabels: [],
    originDonutChartData: [],
    originDonutChartLabels: [],
    componentKey: 0,
    tab: 'stacked bar',
    items: ["table", "stacked bar", "donut", "krona"],
    level: "Species",
    levels: [
      "Domain",
      "Phylum",
      "Class",
      "Order",
      "Family",
      "Genus",
      "Species"
    ],
    result: "Taxa Relaxed",
    results: [
      "Taxa Relaxed",
      "MetaCyc Pathways",
      "Enzyme Commission",
      "FASTQC"      
    ],
    color: [
      'rgba(253, 127, 111, 0.8)', 'rgba(126, 176, 213, 0.8)', 'rgba(178, 224, 97, 0.8)', 'rgba(189, 126, 190, 0.8)', 'rgba(255, 181, 90, 0.8)', 'rgba(255, 238, 101, 0.8)',
      'rgba(190, 185, 219, 0.8)', 'rgba(139, 211, 199, 0.8)', 'rgba(0, 255, 200, 0.8)', 'rgba(0, 127, 255, 0.8)', 'rgba(0, 0, 255, 0.8)',
      'rgba(127, 0, 255, 0.8)', 'rgba(255, 0, 255, 0.8)', 'rgba(255, 127, 255, 0.8)', 'rgba(255, 0, 0, 0.8)', 'rgba(255, 127, 0, 0.8)','rgba(255, 200, 0, 0.8)',
      'rgba(127, 200, 0, 0.8)', 'rgba(0, 200, 0, 0.8)', 'rgba(0, 200, 127, 0.8)',
      'rgba(253, 127, 111, 0.6)', 'rgba(126, 176, 213, 0.6)', 'rgba(178, 224, 97, 0.6)', 'rgba(189, 126, 190, 0.6)', 'rgba(255, 181, 90, 0.6)', 'rgba(255, 238, 101, 0.6)',
      'rgba(190, 185, 219, 0.6)', 'rgba(139, 211, 199, 0.6)', 'rgba(0, 255, 200, 0.6)', 'rgba(0, 127, 255, 0.6)', 'rgba(0, 0, 255, 0.6)',
      'rgba(127, 0, 255, 0.6)', 'rgba(255, 0, 255, 0.6)', 'rgba(255, 127, 255, 0.6)', 'rgba(255, 0, 0, 0.6)', 'rgba(255, 127, 0, 0.6)','rgba(255, 200, 0, 0.6)',
      'rgba(127, 200, 0, 0.6)', 'rgba(0, 200, 0, 0.6)', 'rgba(0, 200, 127, 0.6)',
      'rgba(253, 127, 111, 0.4)', 'rgba(126, 176, 213, 0.4)', 'rgba(178, 224, 97, 0.4)', 'rgba(189, 126, 190, 0.4)', 'rgba(255, 181, 90, 0.4)', 'rgba(255, 238, 101, 0.4)',
      'rgba(190, 185, 219, 0.4)', 'rgba(139, 211, 199, 0.4)', 'rgba(0, 255, 200, 0.4)', 'rgba(0, 127, 255, 0.4)', 'rgba(0, 0, 255, 0.4)',
      'rgba(127, 0, 255, 0.4)', 'rgba(255, 0, 255, 0.4)', 'rgba(255, 127, 255, 0.4)', 'rgba(255, 0, 0, 0.4)', 'rgba(255, 127, 0, 0.4)','rgba(255, 200, 0, 0.4)',
      'rgba(127, 200, 0, 0.4)', 'rgba(0, 200, 0, 0.4)', 'rgba(0, 200, 127, 0.4)',
      'rgba(253, 127, 111, 0.2)', 'rgba(126, 176, 213, 0.2)', 'rgba(178, 224, 97, 0.2)', 'rgba(189, 126, 190, 0.2)', 'rgba(255, 181, 90, 0.2)', 'rgba(255, 238, 101, 0.2)',
      'rgba(190, 185, 219, 0.2)', 'rgba(139, 211, 199, 0.2)', 'rgba(0, 255, 200, 0.2)', 'rgba(0, 127, 255, 0.2)', 'rgba(0, 0, 255, 0.2)',
      'rgba(127, 0, 255, 0.2)', 'rgba(255, 0, 255, 0.2)', 'rgba(255, 127, 255, 0.2)', 'rgba(255, 0, 0, 0.2)', 'rgba(255, 127, 0, 0.2)','rgba(255, 200, 0, 0.2)',
      'rgba(127, 200, 0, 0.2)', 'rgba(0, 200, 0, 0.2)', 'rgba(0, 200, 127, 0.2)', 
      'rgba(253, 127, 111, 1)', 'rgba(126, 176, 213, 1)', 'rgba(178, 224, 97, 1)', 'rgba(189, 126, 190, 1)', 'rgba(255, 181, 90, 1)', 'rgba(255, 238, 101, 1)',
      'rgba(190, 185, 219, 1)', 'rgba(139, 211, 199, 1)', 'rgba(0, 255, 200, 1)', 'rgba(0, 127, 255, 1)', 'rgba(0, 0, 255, 1)',
      'rgba(127, 0, 255, 1)', 'rgba(255, 0, 255, 1)', 'rgba(255, 127, 255, 1)', 'rgba(255, 0, 0, 1)', 'rgba(255, 127, 0, 1)','rgba(255, 200, 0, 1)',
      'rgba(127, 200, 0, 1)', 'rgba(0, 200, 0, 1)', 'rgba(0, 200, 127, 1)',          
    ],
    gridProps: {
      bodyHeight: 570,
      pageOptions: {
        useClient: true,
        perPage: 14
      },
      columnOptions: {
        resizable: false,
      },
      data: [],
      columns: [
        {
          header: 'Name',
          name: 'name',
          sortable: true,
          filter: {
            type: 'text',
            showApplyBtn: true,
            showClearBtn: true
          },
        },
        { 
          header: "300-AP-2", 
          name: "300-AP-2",
          width: 120,
          align: 'right',
          sortable: true,
          filter: {
            type: 'text',
            showApplyBtn: true,
            showClearBtn: true
          },
          renderer: {
            type: CustomText
          },
        }
      ],  
      options: {
        rowHeaders: ['rowNum'],
        treeColumnOptions: {
          name: 'sampleName',
          useIcon: true,
          useCascadingCheckbox: true
        }
      },
      myTheme: {
        name: "myTheme",
        value: {
          row: {
            even: {},
            hover: {
              background: '#EEEEEE'
            }
          },
          cell: {
            normal: {
              background: '#FFFFFF',
            },
            header: {
            },
            rowHeader: {
            },
            editable: {
            },
            selectedHeader: {
            },
            focused: {
              border: '#1E88E5'
            },
            disabled: {
            }
          }
        }
      },
    },
  }),
  computed: {
    databaseOptions: function () {
      return this.target === '16S' || this.target === '18S' ? ['Silva r138', 'Greengenes 13_5'] : this.target === 'ITS' ? ['UNITE ver 9.0'] : []
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    numberWithCommas() {
      return function (number) {
        if (number) {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      };
    },
  },
  watch: {
    async reset(val) {
      await this.init();
      await this.loadKrona(this.kronaPath);
      this.componentKey += 1;
      return;
    },
    level(val) {
      this.sendLevel(val);
      return;
    },
    async database(val) {
      this.level = 'Species'
      await this.loadTaxoData();
      await this.loadKrona(this.kronaPath);
      return;
    }
  },
  created() {
  },
  async mounted() {
    await this.checkSessionStorage();
    await this.init();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    async checkSessionStorage() {
      let rowData = sessionStorage.taxonomy;
      if (rowData) {
        this.selectedRowDataSaved = JSON.parse(rowData).selectedRowData;
        this.reset = JSON.parse(rowData).reset;
      } else {
        this.selectedRowDataSaved = this.selectedRowData
      }
      return;
    },
    sendLevel(val) {
      const iframe = this.$refs.iframe;
      const index = this.levels.findIndex(level => level == val)
      iframe.contentWindow.maxAbsoluteDepthDecrease(index + 3); 
      return;
    },
    levelIncrease(beforeMaxDepth) {
      let level = ''
      switch(beforeMaxDepth) {
        case 8:
          level = this.levels[6];
          break;
        case 7:
          level = this.levels[5];
          break;
        case 6:
          level = this.levels[4];
          break;
        case 5:
          level = this.levels[3];
          break;
        case 4:
          level = this.levels[2];
          break;
        case 3:
          level = this.levels[1];
          break;
        case 2:
          level = this.levels[0];
          break;
      }
      this.level = level;
      return;
    },
    maxAbsoluteDepthIncrease(window) {
      const beforeMaxDepth = window.view.maxAbsoluteDepth
      this.levelIncrease(beforeMaxDepth);
    },
    levelDecrease(beforeMaxDepth) {
      let level = ''
      switch(beforeMaxDepth) {
        case 8:
          level = this.levels[6];
          break;
        case 7:
          level = this.levels[5];
          break;
        case 6:
          level = this.levels[4];
          break;
        case 5:
          level = this.levels[3];
          break;
        case 4:
          level = this.levels[2];
          break;
        case 3:
          level = this.levels[1];
          break;
        case 2:
          level = this.levels[0];
          break;
      }
      this.level = level;
      return;
    },
    maxAbsoluteDepthDecrease(window) {
      const beforeMaxDepth = window.view.maxAbsoluteDepth
      this.levelDecrease(beforeMaxDepth);
    },
    checkMobile() {
      this.isMobile = this.$vuetify.breakpoint.xs;
    },
    async init() {
      this.level = 'Species';
      await this.loadTaxoData();
      const serviceForTaxo = this.selectedRowDataSaved.serviceForTaxo;
      this.target = serviceForTaxo.includes('16S') ? '16S' : serviceForTaxo.includes('18S') ? '18S' : 'ITS';
      this.database = this.target === '16S' || this.target === '18S' ? 'Silva r138' : 'UNITE ver 9.0';
      await this.loadKrona(this.kronaPath);
      return;
    },
    async checkLevelData(level) {
      try {
        const sampleName = this.selectedRowDataSaved.sampleName
        const database = this.database;
        const companyCode = this.selectedRowDataSaved.companyCode;
        const orderNum = this.selectedRowDataSaved.order_num;
        const fastqcReportR1 = this.selectedRowDataSaved.fastqcReport.R1;
        this.changeColumnName(sampleName);
        const params = { sampleName, level, orderNum, database, companyCode, fastqcReportR1 }
        const res = await this.$axios.post(`${this.$apiHost}/taxonomy/getTaxoData`, params);
        const processingData = this.processingCsvData(res.data.csvData, sampleName);
        return processingData;
      } catch (error) {
        console.error(error);
      }
    },
    exportTable() {
      const level = this.level;
      const sampleName = this.selectedRowDataSaved.sampleName;
      const database = this.database;
      function downloadCSV(data) {
        const csvContent = convertToCSV(data);
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${sampleName}_${database}_${level}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      function convertToCSV(data) {
        const keys = Object.keys(data[0]);
        const csvRows = [];
        csvRows.push(keys.join(','));

        data.forEach((item) => {
          const values = Object.values(item);
          const row = values.map((value) => {
            if (typeof value === 'string' && value.includes(',')) {
              return `"${value}"`;
            }
            return value;
          });
          csvRows.push(row.join(','));
        });

        return csvRows.join('\n');
      }
      downloadCSV(this.originData);
    },
    exportChart(URL) {
      try {
        var link = document.createElement("a");
        link.download = "myChart.png";
        link.href = URL;
        link.click();
        this.getBarChart = false;
        this.getDonutChart = false;        
      } catch (error) {
        console.log(error)
      }
      return false;
    },
    linkFastQC(type) {
      try {
        let fastqcReport = '';
        if (type == 'R1') {
          fastqcReport = `https://lims.accugenelab.com${this.selectedRowDataSaved.fastqcReport.R1.replace('/data/lims', '')}`;
        } else {
          fastqcReport = `https://lims.accugenelab.com${this.selectedRowDataSaved.fastqcReport.R2.replace('/data/lims', '')}`;
        }
        window.open(fastqcReport)
      } catch (error) {
        console.log(error)
      }
    },
    async loadKrona(kronaPath) {
      try {
        let processingData = await this.checkLevelData('domain');
        let minAbsoluteDepth = 3;

        if (processingData.length > 1) {
          minAbsoluteDepth = 2;
        }

        const params = {
          kronaPath
        }
        const res = await this.$axios.post(`${this.$apiHost}/taxonomy/krona`, params);
      if (res.statusText === 'OK') {
        let fileContent = res.data;
        fileContent = fileContent.replace('id="maxAbsoluteDepthDecrease" value="-"/>', 'id="maxAbsoluteDepthDecrease" value="-" onclick="window.parent.app.maxAbsoluteDepthDecrease(maxDepth)"/>');
        fileContent = fileContent.replace('id="maxAbsoluteDepthIncrease" value="+"/>', 'id="maxAbsoluteDepthIncrease" value="+" onclick="window.parent.app.maxAbsoluteDepthIncrease(maxDepth)"/>');
        fileContent = fileContent.replace(`function maxAbsoluteDepthDecrease()
{
	if ( maxAbsoluteDepth > 2 )
	{
		maxAbsoluteDepth--;
		head.setMaxDepths();
		handleResize();
	}
}`, `function maxAbsoluteDepthDecrease(value)
{
	if (typeof value == 'number') {
		maxAbsoluteDepth = value
	}
	if ( maxAbsoluteDepth > ${minAbsoluteDepth} )
	{
		maxAbsoluteDepth--;
		head.setMaxDepths();
		handleResize();
	}
}`);
        this.fileContent = fileContent;

        if (this.$refs.iframe != undefined) {
          let check = true;
          const iframe = this.$refs.iframe;
          this.$refs.iframe.onload = async () => {
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            const button = iframeDocument.getElementById('maxAbsoluteDepthDecrease');
            button.addEventListener('click', this.maxAbsoluteDepthDecrease);
            const button2 = iframeDocument.getElementById('maxAbsoluteDepthIncrease');
            button2.addEventListener('click', this.maxAbsoluteDepthIncrease);
            // this.componentKeyForKrona += 1;
            this.check = false;
            this.sendLevel(this.level);
          };
          setTimeout(() => {
            if (check) {
              const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
              const button = iframeDocument.getElementById('maxAbsoluteDepthDecrease');
              button.addEventListener('click', this.maxAbsoluteDepthDecrease);
              const button2 = iframeDocument.getElementById('maxAbsoluteDepthIncrease');
              button2.addEventListener('click', this.maxAbsoluteDepthIncrease);
              this.sendLevel(this.level);
            }
          }, 1000); 
        }
      }
      return false;
      } catch (error) {
        console.error(error);
      }
    },
    changeColumnName(sampleName) {
      this.gridProps.columns = [
        {
          header: 'Name',
          name: 'name',
          sortable: true,
          filter: {
            type: 'text',
            showApplyBtn: true,
            showClearBtn: true
          },
        },
        { 
          header: sampleName, 
          name: sampleName,
          width: 120,
          align: 'right',
          sortable: true,
          // filter: {
          //   type: 'text',
          //   showApplyBtn: true,
          //   showClearBtn: true
          // },
          renderer: {
            type: CustomText
          },
        }
      ]
      this.componentKey += 1;
    },
    async loadTaxoData() {
      try {
        const sampleName = this.selectedRowDataSaved.sampleName
        const level = this.level;
        const database = this.database;
        const companyCode = this.selectedRowDataSaved.companyCode;
        const orderNum = this.selectedRowDataSaved.order_num;
        const fastqcReportR1 = this.selectedRowDataSaved.fastqcReport.R1;
        this.changeColumnName(sampleName);
        const params = { sampleName, level, orderNum, database, companyCode, fastqcReportR1 };

        const res = await this.$axios.post(`${this.$apiHost}/taxonomy/getTaxoData`, params);
        if (res.statusText === 'OK') {
          this.originData = res.data.csvData;
          let processingData = this.processingCsvData(res.data.csvData, sampleName);
          // processingData = processingData.filter(obj => obj.name && !obj.name.includes('Unassigned'))
          processingData = _.sortBy(processingData, 'name');
          let tableData = _.cloneDeep(processingData);
          for (let i of tableData) {
            let data = i[sampleName];
            i['sampleName'] = Math.round(data * 100) / 100
            if (i['sampleName'] == 0) {
              i['sampleName']  = Math.round(data * 1000) / 1000;
            }
            if (i['sampleName'] == 0) {
              i['sampleName'] = Math.round(data * 10000) / 10000;
            }
          }
          this.gridProps.data = tableData;

          for (let i of processingData) {
            let divideName = i.name.split(';');
            let endDivideName = divideName.pop();
            let t = 0
            while (endDivideName == '__' && divideName.length > 0) {
              if (t !== 0) {
              }
              endDivideName = divideName.pop();
              t += 1;
            }
              i.name = endDivideName.substring(3);
          }
          let barChartData = processingData.map((item) => {
            let num = new Big(item.originNum);
            num = Math.floor(Number(num) * 10000) / 10000;

            return {
              label: item.name,
              data: [num.toString()]
            };
          });
          
          this.barChartData = barChartData
          this.originBarChartData = this.barChartData;
          this.relativeAbundance(this.relativeNum); // bar chart data

          const donutChartData = processingData.map(i => i.originNum);
          const donutChartLabels = processingData.map(i => i.name);

          for (let i = 0; i < donutChartData.length; i++) {
            let num = new Big(donutChartData[i]);
            donutChartData[i] = Math.floor(Number(num) * 10000) / 10000;
          }

          this.donutChartData = donutChartData;
          this.donutChartLabels = donutChartLabels;
          this.originDonutChartData = donutChartData;
          this.originDonutChartLabels = donutChartLabels;
          this.relativeAbundanceForD(this.relativeNum); // donut chart data
        }else {
        }
        this.kronaPath = res.data.kronaPath;
        this.componentKey += 1;
        return res.data.kronaPath;
      } catch (error) {
        console.log(error);
      }
    },
    processingCsvData(data, sampleName) {
      let processingData = data.map(obj => {
        let newObj = {};
        for (let key in obj) {
          if (key === "") {
            newObj["name"] = obj[key];
          } else if (key === sampleName) {
            newObj.originNum = obj[key] * 100;
            const factor = Math.pow(10, obj[key].split('.')[1].length + 2);
            let value = Number(obj[key]) * factor;
            if (value !== 0) {
              value = Math.round(value);
              newObj[key] = value / factor * 100;
              newObj[key] = Math.round(newObj[key] * 10000) / 10000;
            } else {
              newObj[key] = Math.round(Number(obj[key]) * 100 * 10000) / 10000;
            }
          } else {
            newObj[key] = obj[key];
          }
        }
        return newObj;
      });
      return processingData;
    },
    relativeAbundance(num) {
      let others = [];
      let output = [];
      let barChartData = this.originBarChartData;

      try {
        for (const i of barChartData) {
          if (Number(i.data[0]) < num) {
            others.push(i)
          } else {
            output.push(i)
          }
        }
        let data = 0;
        for (const i of others) {
          data += Number(i.data);
        }
        const color = this.color;
        const outputLength = output.length;
        output = output.map((item, index) => {            
          return {
            label: item.label,
            backgroundColor: color[index % color.length],
            data: item.data
          }
        });
        output.push({
          label: 'Others',
          backgroundColor: color[outputLength],
          data: [Math.round(data * 1000) / 1000]
        })
        this.barChartData = output;
        this.barChartDataLength = output.length > 24 ? 765 : 490;
        this.barChartDataLength = output.length > 48 ? 970 : this.barChartDataLength;
        this.barChartDataLength = output.length > 72 ? 1193 : this.barChartDataLength;
        this.barChartDataLength = output.length > 96 ? 1375 : this.barChartDataLength;
        this.componentKey += 1;
      } catch (error) {
        console.log(error)
        this.barChartData = this.originBarChartData;
      }
    },
    relativeAbundanceForD(num) {
      let outputData = []
      let outputLabels = [];
      let others = 0;
      try {
        let donutChartData = this.originDonutChartData;
        let donutChartLabels = this.originDonutChartLabels;
        for (let i = 0; i < donutChartData.length; i++) {
          if (Number(donutChartData[i]) < num) {
            others += Number(donutChartData[i]);
          } else {
            outputData.push(donutChartData[i]);
            outputLabels.push(donutChartLabels[i]);
          }
        }
        outputData.push(Math.round(others * 1000) / 1000);
        outputLabels.push('Others');

        this.donutChartData = outputData;
        this.donutChartLabels = outputLabels;
        
        this.donutChartDataLength = 1050;
        this.donutChartDataLength = outputLabels.length > 50 ? 1100 : this.donutChartDataLength;
        this.donutChartDataLength = outputLabels.length > 75 ? 1350 : this.donutChartDataLength;
        this.donutChartDataLength = outputLabels.length > 100 ? 1500 : this.donutChartDataLength;

        this.componentKey += 1;
      } catch (error) {
        console.log(error)
        this.donutChartData = this.originDonutChartData;
        this.donutChartLabels = this.originDonutChartLabels;
      }      
    }
  }
};
</script>

<style scoped>
.title_box {
  display:flex;
  justify-content:space-between;
}
.chip_box {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.chip {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* width: 200px; */
}
.chip_title {
  font-weight:500;
  font-size:15px;
  color:#757575;
  text-align:center;
}
.select_box {
  /* margin: 3px 40px -25px 10px !important; */
  margin: 5px 10px -20px 10px !important;
  font-size:15px !important;
}
.breadcrumbs_box {
  display:flex;
  justify-content:flex-end;
  margin:-15px 10px;
  font-weight: bold;
}
.custom-input {
  position: relative;
  border: none;
  border-bottom: 2px solid #ccc;
  outline: none;
  text-align: center;
  width: 56px;
  font-size: 16px;
  transition: border-bottom-color 0.3s;
}

.custom-input:focus {
  border-bottom-color: #1976d2;
}

.custom-input::before,
.custom-input::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 0;
  height: 2px;
  background-color: #1976d2;
  transition: width 0.3s;
}

.custom-input::before {
  left: 0;
}

.custom-input::after {
  right: 0;
  content: '%'; /* % 문자 추가 */
  transform: translateY(50%); /* 중앙 정렬 */
  font-size: 14px; /* 폰트 크기 조정 */
}

.custom-input:focus::before,
.custom-input:focus::after {
  width: 50%;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
}

.custom-input:focus::before {
  transition-delay: 0.1s;
}

.custom-input:focus::after {
  transition-delay: 0.2s;
}
</style>